export const LEVELS = [
  {
    id: "basic",
    label: "Basic",
    tagline: "Sto iniziando",
    description: "Sto ancora cercando di capire il mondo delle protesi.",
    problems: ["Dubbi iniziali", "Paura", "Scelta della prima protesi", "Tipi di sistema", "Aspettative", "Aspetti emotivi", "Altro"],
  },
  {
    id: "intermedio",
    label: "Intermedio",
    tagline: "La porto già, ma qualcosa non funziona",
    description: "Uso già una protesi ma ho problemi nella vita quotidiana.",
    problems: ["Colla che non tiene", "Front che si solleva", "Prurito e irritazione", "Pulizia", "Manutenzione", "Sudore e sport", "Durata", "Residui di adesivo", "Altro"],
  },
  {
    id: "esperto",
    label: "Esperto",
    tagline: "Voglio perfezionare quello che faccio",
    description: "Ho esperienza e voglio ottimizzare il mio sistema.",
    problems: ["Ottimizzazione della tenuta", "Manutenzione avanzata", "Naturalezza", "Densità", "Styling", "Tecniche avanzate", "Errori tecnici", "Altro"],
  },
];

export const PROBLEMS = [...new Set(LEVELS.flatMap((l) => l.problems))];

export const TOPICS = [
  "Scelta del sistema",
  "Manutenzione e prodotti",
  "Applicazione e adesivi",
  "Problemi durante l'utilizzo",
  "Aspetto e naturalezza",
  "Costi e durata",
  "Cambiare sistema o soluzione",
  "Altro",
];

export const SYSTEM_TYPES = ["Lace", "Skin", "Ibrida", "Non lo so"];

export const LOGO_URL = "/logo-masthead.png";
